import React from 'react';
import EditarObjetos from '../../../components/insumos/objetos/EditarObjetos';

const InsumosEditarPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Editar Clasificacion Insumos</h1>
      <br />
      <br />
        <EditarObjetos />
    </div>
  );
};

export default InsumosEditarPage;